import React from 'react';
import './Venue.css';

import { FaRulerCombined, FaUsers } from 'react-icons/fa'; // Importing icons
import { Link } from 'react-router-dom'; // Importing Link for navigation


const Venue = ({ venue }) => {

  return (
    <div className='venue-item' key={venue.id}>

      <img src={venue.image} alt={venue.title} /> {/* Venue image */}

      <div className='content'>

        {/* Venue Title with dynamic navigation */}
        <Link
          to={{
            pathname: '/Venues/' + venue.title,
          }}
          state={venue}>
            <h3>{venue.title}</h3> {/* Venue Title */}
        </Link>

        <p>{venue.details.address}</p> {/* Venue Address */}

        <div className='details'>

          {/* Venue Capacity */}
          <h5>
            <div className='icon'><FaUsers /></div>
            <span>Capacity: {venue.details.capacity}</span>
          </h5>

          {/* Venue Area */}
          <h5>
            <div className='icon'><FaRulerCombined /></div>
            <span>{venue.details.area}</span>
          </h5>

        </div>

      </div>

    </div>
  );
};

export default Venue;